var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import isMobileDevice from "@irati/utils/mobile";
import { Wrapper, StyledLink, InlinePara } from "./styled";
var ContinueOnline = /** @class */ (function (_super) {
    __extends(ContinueOnline, _super);
    function ContinueOnline() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContinueOnline.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, link = _a.link, isGrey = _a.isGrey, isMarginLarge = _a.isMarginLarge, text = _a.text, activationCode = _a.activationCode, formatMessage = _a.formatMessage;
        if (isMobileDevice()) {
            return null;
        }
        return (React.createElement(Wrapper, { isMarginLarge: isMarginLarge },
            React.createElement(InlinePara, { isGrey: isGrey },
                React.createElement(FormattedMessage, { id: "medical.code.continueOnline.text" })),
            React.createElement(StyledLink, { isGrey: isGrey, onClick: onClick, inBody: true, uppercase: false, href: formatMessage({ id: link }, { activationCode: activationCode }), target: "_blank", rel: "noopener noreferrer" },
                React.createElement(FormattedMessage, { id: text }))));
    };
    return ContinueOnline;
}(PureComponent));
export default injectIntl(ContinueOnline);
